import { render, staticRenderFns } from "./Advance.vue?vue&type=template&id=adbc0f46&scoped=true&"
import script from "./Advance.vue?vue&type=script&lang=js&"
export * from "./Advance.vue?vue&type=script&lang=js&"
import style0 from "./Advance.vue?vue&type=style&index=0&id=adbc0f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbc0f46",
  null
  
)

export default component.exports